
import { ParallaxEffect, ParallaxContext } from '@/render/parallax/ParallaxEffect';
import { BaseParallaxEffect } from '@/render/parallax/BaseParallaxEffect';

export class EntropyHeatDeathEffect extends BaseParallaxEffect implements ParallaxEffect {
    public render(pc: ParallaxContext): void {
        const { ctx, layerIndex, config, time, width, height } = pc;
         const count = Math.floor(200 * (config.parallaxComplexity || 1.0));
        const scale = config.parallaxScale || 1.0;

        ctx.fillStyle = pc.color;

        const draw = () => {
             ctx.save();
             ctx.globalAlpha *= 0.1 / (layerIndex + 1);
            for (let i = 0; i < count; i++) {
                // Expanding randomness
                const rx = (this.pseudoRandom(i + Math.floor(time * 2)) - 0.5) * width * 3;
                const ry = (this.pseudoRandom(i + 100 + Math.floor(time * 2)) - 0.5) * height * 3;
                const s = (1 + this.pseudoRandom(i) * 2) * scale;
                ctx.fillRect(rx, ry, s, s);
            }
            ctx.restore();
        };

        draw();
        this.applyGlow(pc, draw);
    }
}
